export const LIENS_DEBTOR_TABLE_CHANGE = 'LIENS_DEBTOR_TABLE_CHANGE'
export const LIENS_DEBTOR_TABLE_CHANGE_REQUEST = (id) => `LIENS_${id}_DEBTOR_TABLE_CHANGE_REQUEST`
export const LIENS_DEBTOR_TABLE_LOADING_TRUE = 'LIENS_DEBTOR_TABLE_LOADING_TRUE'
export const LIENS_DEBTOR_TABLE_LOADING_FALSE = 'LIENS_DEBTOR_TABLE_LOADING_FALSE'
export const LIENS_DEBTOR_TABLE_DATA_RECEIVED = 'LIENS_DEBTOR_TABLE_DATA_RECEIVED'
